'use strict';

namespace Core {

    export class ScSidebar {

        // bound
        toggleEvent: string;

        public isOpen: boolean = false;

        private element: JQuery;
        private context: JQuery;
        private backdrop: JQuery;

        private lastContextOverflow: string;
        private animating: boolean = false;
        private visible: boolean = false;
        private sidebarStyle: any;

        private componentNamespace: string = 'sc-c-sidebar-';
        private eventNamespace: string = `.${this.componentUtil.getRandomID(this.componentNamespace)}`;

        private event = {
            clickaway: (event) => {
                event.preventDefault();
                this.$scope.$apply(() => this.close(true));

            },
            escape: (event) => {
                let isEscape = (event.keyCode === 27);
                if (isEscape) {
                    this.$scope.$apply(() => this.close(true));
                }
            }
        };

        private bind = {
            clickaway: () => {
                this.backdrop
                    .on(`click${this.eventNamespace}`, this.event.clickaway)
                    .on(`touchend${this.eventNamespace}`, this.event.clickaway);
            },
            keydown: () => {
                this.context
                    .on(`keydown${this.eventNamespace}`, this.event.escape);
            },
            scrollLock: () => {
                // disable browser scroll bar
                this.lastContextOverflow = this.context.css('overflow');
                this.context.css('overflow', 'hidden');
            }
        };

        private unbind = {
            clickaway: () => {
                this.backdrop.off(this.eventNamespace);
            },
            keydown: () => {
                this.context.off(this.eventNamespace);
            },
            scrollLock: () => {
                // enable browser scroll bar
                this.context.css('overflow', this.lastContextOverflow);
                this.lastContextOverflow = '';
            }
        };

        constructor (
            private $scope: ng.IScope,
            private broker: any,
            private animationUtil: any,
            private $rootScope: ng.IRootScopeService,
            private $location: ng.ILocationService,
            private componentUtil: TR.ComponentUtil
        ) {
        }

        init (element : ng.IAugmentedJQuery): void {
            this.element = element;

            // presume context is the parent element (most likely the body)
            this.context = this.element.parent();

            // create a hidden backdrop and append it to our context element
            this.backdrop = $('<div class="sc-o-backdrop sc-o-backdrop--sidebar is-hidden"></div>');
            this.backdrop.appendTo(this.context);

            this.broker.subscribe('SidebarToggle', this.toggleEvent, e => {
                this.$scope.$apply(() => this.toggle());
            });

            this.$scope.$on('$destroy', this.destroy);

            this.$rootScope.$on('$routeChangeStart', () => {
                this.shut();
            });

            this.sidebarStyle = {
                'visibility': `hidden`
            };
        }

        private destroy() {
            _.forEach(this.unbind, (handler) => {
                handler();
            });
            this.backdrop && this.backdrop.remove();
        }

        public toggle(): void {
            this.isOpen ? this.close(true) : this.open();
        }

        private open(): void {
            if (this.isOpen) {
                return;
            }
            this.isOpen = true;

            // animate the backdrop
            this.backdrop.removeClass('is-hidden').addClass('is-dimmed');

            this.bind.scrollLock();

            // animate the sidebar
            this.animating = true;
            this.visible = true;

            this.sidebarStyle = {
                'visibility': `visible`
            };

            this.animationUtil.waitForTransition(this.element).then((el) => {
                this.animating = false;
                this.bind.clickaway();
                this.bind.keydown();
            });
        }

        private close(animate: boolean): void {
            if (!this.isOpen) {
                return;
            }

            if (animate) {
                // animate backdrop
                this.backdrop.removeClass('is-dimmed');
                this.animationUtil.waitForTransition(this.backdrop).then((el) => {
                    // hide the backdrop
                    this.backdrop.addClass('is-hidden');
                });

                // animate sidebar
                this.animating = true;
                this.visible = false;
                this.animationUtil.waitForTransition(this.element).then((el) => {
                    this.animating = false;
                    this.isOpen = false;
                    this.sidebarStyle = {
                        'visibility': `hidden`
                    };
                });
            } else {
                // hide the backdrop and hide sidebar
                this.backdrop.removeClass('is-dimmed').addClass('is-hidden');
                this.visible = false;
                this.isOpen = false;
                this.sidebarStyle = {
                    'visibility': `hidden`
                };
            }

            this.unbind.clickaway();
            this.unbind.keydown();
            this.unbind.scrollLock();

        }

        public shut(): void {
            this.close(false);
        }
    }

    angular
        .module('core')
        .directive('scSidebar', (): ng.IDirective => {

            return {
                scope: {},
                restrict: 'E',
                replace: true,
                transclude: true,
                controller: ScSidebar,
                controllerAs: 'sb',
                bindToController: {
                    toggleEvent: '='
                },
                template: `<div class="sc-c-sidebar"
                                ng-class="{'is-animating': sb.animating, 'is-visible': sb.visible}"
                                ng-style="sb.sidebarStyle"
                                ng-transclude>                   
                           </div>`,
                link: (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr: ng.IAttributes,
                    controller: ScSidebar
                ) => {
                    controller.init(el);
                }
            };

        });
}
